/**
 *
 * @desc Countdown utility function
 * @param {object} options
 *
 */
function CountdownUtil({
    seconds = 0,
    signal = () => null,
    complete = () => null,
}) {

    let remaining = seconds;
    let clearInstance;

    const interval = setInterval(() => {

        if (remaining === 0) {

            clearInstance();
            complete();

        } else {

            signal(--remaining);

        }

    }, 1000);

    clearInstance = () => clearInterval(interval);

    return { cancel: clearInstance };

}

export default CountdownUtil;
